import React, { useEffect, useState } from 'react'; 
import { ProgressSpinner } from 'primereact/progressspinner';

import Introduction from '../sections/Home/Introduction';
import Experience from '../sections/Home/Experience';
import Featured from '../sections/Home/Featured';
import Footer from '../components/Footer';
import { buildApiUrl } from '../utils/api';

import '../static/styles/Home.css';

export default function Home() {
    const [data, setData] = useState(null);

    useEffect(() => {
        const controller = new AbortController();
        const homeEndpoint = buildApiUrl('/home');

        fetch(homeEndpoint, { signal: controller.signal })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch home content: ${response.status}`);
                }

                return response.json();
            })
            .then((payload) => setData(payload))
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error("Error fetching data for home:", error);
                }
            });

        return () => controller.abort();
    }, []);
    
    return (
        <>
            {data ? (
                <>
                    <Introduction resume={data.resume} />
                    <Experience data={data.experience} />
                    <Featured data={data.featured_projects} />
                    <Footer />
                </>
            ) : (
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "75vh",
                }}>
                    <ProgressSpinner 
                        style={{ width: '5rem', height: '5rem' }} 
                        strokeWidth="8" 
                        fill="var(--surface-ground)" 
                        animationDuration=".5s" 
                    />
                </div>
            )}
        </>
    );
}
